define('StellarGrade.ST_Common.SupportCaseForm.View', ['stellargrade_st_common_support_case_form.tpl', 'Utils', 'jQuery', 'underscore', 'Backbone', 'Configuration'], function (
    stellargrade_st_common_support_case_form_tpl,
    Utils,
    $,
    _,
    Backbone,
    Configuration
) {
    'use strict';

    var currentDomain = window.location.origin;
    const SANDBOX = currentDomain === 'https://stagingsb1.stealth.com' ? true : false;
    const IS_SANDBOX2 = currentDomain === 'https://stagingsb2.stealth.com' ? true : false;


    const URL_CREATE_SUPPORT_CASE_SB =
        'https://439653-sb1.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2316&deploy=1&compid=439653_SB1&ns-at=AAEJ7tMQKeEKnNF2beKeVOTPCclWVdP9dv04m6GldCrP-SIc-eI';

    if (IS_SANDBOX2) {
        URL_CREATE_SUPPORT_CASE_SB = '';
    }
    const URL_CREATE_SUPPORT_CASE_PROD =
        'https://439653.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2316&deploy=1&compid=439653&ns-at=AAEJ7tMQOM24urXVAuR6723hGBYFSDx8a1WE_77hy_lx70RlGFs';

    const WEBSITE_TERMS_ATTACHMENT = SANDBOX ? 7758271 : 7758271; // 7758271 prod // 7591240 SB

    const FILE_TYPE_MAP = {
        'text/csv': 'CSV',
        'application/pdf': 'PDF',
        'application/vnd.ms-excel': 'EXCEL',
        'image/jpeg': 'JPGIMAGE',
        'text/plain': 'PLAINTEXT',
        'image/png': 'PNGIMAGE',
        'application/msword': 'WORD',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'WORD',
        'application/xml': 'XMLDOC',
    };

    function isSupportCaseUrl() {
        return window.location.href.includes('support-case');
    }

    var SupportCaseFormView = Backbone.View.extend({
        template: stellargrade_st_common_support_case_form_tpl,
        events: {
            'change #support-case-upload': 'handleFileAdd',
            'submit #support-case-form': 'handleFormSubmit',
        },

        handleFileAdd: function (event) {
            const file = event.target.files[0];
            this.fileUploadValid = true;
            this.uploadedFileData = null; // Reset uploaded file data
            if (!file) return;

            $('#support-case-upload-error').remove();

            if (file.size > 10 * 1024 * 1024) {
                this.fileUploadValid = false;
                $('.support-case-upload-container').after(`
            <p data-validation-error="block" id="support-case-upload-error" style="color: #c00; margin-top: 5px;">
                The selected file is too large. The maximum file size is 10 megabytes (MB).
            </p>`);
                return;
            }

            if (!FILE_TYPE_MAP[file.type]) {
                this.fileUploadValid = false;
                $('.support-case-upload-container').after(`
            <p data-validation-error="block" id="support-case-upload-error" style="color: #c00; margin-top: 5px;">
                Unsupported file type. Please upload one of the following formats: PDF, DOCX, XLSX, CSV, PNG, JPG, or TXT.
            </p>`);

                return;
            }

            const reader = new FileReader();
            reader.addEventListener(
                'load',
                function () {
                    this.uploadedFileData = {
                        name: file.name + ' - ' + new Date().toISOString(),
                        type: file.type,
                        data: reader.result.split(',')[1], // base64 only
                        folderId: WEBSITE_TERMS_ATTACHMENT,
                        description: 'Support Case File Upload',
                    };
                    this.fileUploadValid = true;
                }.bind(this),
                false
            );

            reader.readAsDataURL(file);
        },

        handleFormSubmit: function (e) {
            e.preventDefault();
            if (this.isSubmitting) return;
            var self = this;
            if (!this.fileUploadValid) {
                alert('Unsupported file type. Please upload one of the following formats: PDF, DOCX, XLSX, CSV, PNG, JPG, or TXT.');
                return;
            }
            this.isSubmitting = true;
            var submitButton = this.$('#support-case-register')[0];
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';
            submitButton.style.backgroundColor = '#6c757d';

            const fileData = this.uploadedFileData;

            var formData = {
                companyName: this.$('#support-case-company').val(),
                firstName: this.$('#support-case-first-name').val(),
                lastName: this.$('#support-case-last-name').val(),
                email: this.$('#support-case-email').val(),
                phone: this.$('#support-case-phone').val(),
                phoneExt: this.$('#support-case-phone-ext').val(),
                country: this.$('#support-case-country').val(),

                custentity_cust_segmentation_pri: 13, // To be Determined

                entityStatus: 6, // LEAD-Unqualified SandBox
                leadsource: 44277, // Website
                salesrep: 43, // House Acct

                casesubject: this.$('#support-case-casesubject').val(),
                casetype: this.$('#support-case-casetype').val(),
                productmodel: this.$('#support-case-productmodel').val(),
                serialnumber: this.$('#support-case-serialnumber').val(),

                upload: fileData,

                explainyourrequest: this.$('#support-case-explainyourrequest').val(),
            };

            var urlSupportCase = SANDBOX ? URL_CREATE_SUPPORT_CASE_SB : URL_CREATE_SUPPORT_CASE_PROD;
            // console.log('formData', formData);

            $.ajax({
                url: urlSupportCase,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(formData),
                success: function (response) {
                    self.isSubmitting = false;
                    submitButton.disabled = false;

                    function showPopup(message) {
                        const popup = document.getElementById('support-case-popup');
                        const msg = document.getElementById('support-case-popup-message');
                        msg.textContent = message;
                        popup.classList.remove('hidden');
                    }

                    function closePopup() {
                        document.getElementById('support-case-popup').classList.add('hidden');

                        if (!SANDBOX) {
                            window.location.href = '/';
                        }
                    }

                    var popup = document.getElementById('support-case-popup');
                    var popupContent = document.querySelector('.support-case-popup-content');

                    document.getElementById('support-case-popup-close').addEventListener('click', function () {
                        closePopup();
                    });

                    if (response.error) {
                        if (response.error.name === 'UNIQUE_CUST_ID_REQD') {
                            showPopup('Email already exists. Please try again with a different email address.');
                            return;
                        } else if (response.error === 'UNIQUE_EMAIL_NAME_REQD') {
                            showPopup('Email already exists linked with another name!');
                            return;
                        }
                    } else {
                        showPopup(response.message);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    alert('An error occurred while submitting the form. Please try again.');
                    self.isSubmitting = false;
                    submitButton.textContent = 'SUBMIT';
                    submitButton.disabled = false;
                    submitButton.hidden = false;
                    submitButton.style.backgroundColor = '#007bff';
                },
            });
        },
        initialize: function () {
            this.fileUploadValid = true;
            this.isFormEnabled = isSupportCaseUrl();

            // This view lives in the Footer, which is only rendered on a full page load. Without
            // listening for route changes the form stays visible after navigating to another page.
            this.listenTo(Backbone.history, 'route', this.refreshFormVisibility);
        },

        refreshFormVisibility: function () {
            if (isSupportCaseUrl() === this.isFormEnabled) {
                return;
            }

            this.render();
        },

        register: function (e) {
            e.preventDefault();
        },
        getContext: function getContext() {
            this.isFormEnabled = isSupportCaseUrl();
            var countries = Configuration.get('siteSettings.countries') || {};
            var countriesArray = _.map(countries, function (country, code) {
                return {
                    code: code,
                    name: country.name,
                };
            });
            const topCountries = [
                { name: 'Canada', code: 'CA', isziprequired: 'T' },
                { name: 'Mexico', code: 'MX', isziprequired: 'T' },
                { name: 'United States', code: 'US', isziprequired: 'T' },
                { name: '------------------------', code: 'XX', isziprequired: 'F' },
            ];

            countriesArray = [...topCountries, ...countriesArray];

            var casetypeSegmentation = [
                { name: 'Question', value: 1 },
                { name: 'Concern', value: 2 },
                { name: 'Problem', value: 3 },
            ];

            return {
                title: 'Support Case Contact Form',
                displayName: 'Support Case Contact Form',
                isSupportCaseformEnabled: this.isFormEnabled,
                countries: countriesArray,
                casetypeSegmentation: casetypeSegmentation,
            };
        },
    });

    return {
        loadModule: function (container) {
            var layout = container.getComponent('Layout');
            if (layout) {
                layout.addChildView('Footer', function () {
                    return new SupportCaseFormView();
                });
            }
        },
    };
});
